import ApiDocumentBaseCard from './ApiDocumentBaseCard';

export const DOCUMENT_ACCESS_LEVEL_DENIED = 0;
export const DOCUMENT_ACCESS_LEVEL_CARD = 1;
export const DOCUMENT_ACCESS_LEVEL_FULL = 2;

export const DOCUMENT_FORMAT_HTML = 'html';
export const DOCUMENT_FORMAT_SCAN = 'scan';

/**
 * Карточка документа результатов поиска.
 *
 * @property {string|null} statusDate
 * @property {string} statusHint
 * @property {string} organization
 * @property {string|null} approvalDate
 * @property {string} area
 * @property {Array<string>} format
 * @property {Array<string>} kind
 * @property {number} checklistsCount
 * @property {boolean} isFavorite
 * @property {boolean} isWatched
 * @property {number} accessLevel
 */
export default class ApiDocumentSearchCard extends ApiDocumentBaseCard {
  constructor(props) {
    super(props);
  }

  /**
   * @returns {boolean}
   */
  hasFormatHtml() {
    return this.format && this.format.includes(DOCUMENT_FORMAT_HTML);
  }

  /**
   * @returns {boolean}
   */
  hasFormatScan() {
    return this.format && this.format.includes(DOCUMENT_FORMAT_SCAN);
  }

  /**
   * @returns {boolean}
   */
  hasAccessFull() {
    return this.accessLevel === DOCUMENT_ACCESS_LEVEL_FULL;
  }
}
